import {  Toast } from "antd-mobile"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import {businessDeposit, } from '@/apis/crypto';
import { FormInstance } from "antd-mobile/es/components/form";

import {dictMap} from './data';
import { isEqual } from "lodash"
import { useGlobalVerify } from "@/logic/verify"
import { useCryptoTradingContext } from "@/stores/cryptoTradingContext";
import { amountFormat } from "@/utils/tool";
const coutCurrent = ( account:any, values:any ) => {
  return amountFormat(
    values.amount && account.otcTicker
      ? values.amount * account.otcTicker
      : 0,
    { places: 0 }
  );
}

const valiedateData = (data: {amount: number, paymentType: string}) => {
  if(!data.amount){
    return ('请输入转入金额');
  }

}

const initFormValue = {
  mainNet: 'Tronscan(TRC20)',
  paymentType: [dictMap['paymentType'][0][0].value],
}
const isBuyVb = false;
let orderType = 'TronTransferBusiness';


export const useLogic = () => {
  const formRef = useRef<FormInstance>();
  const [data, setData] = useState<any>({...initFormValue});
  const [verifySecurePassword] = useGlobalVerify();


  const navigate = useNavigate();
  const cryptoTradingStore = useCryptoTradingContext();
  const isTrading = useMemo(() => {
    return cryptoTradingStore.countdown;
  }, [cryptoTradingStore.countdown])

  useEffect(() => {
    if(isTrading){  
      const current = coutCurrent( cryptoTradingStore.cryptoAccountInfo, {amount:cryptoTradingStore.form.amount });
      formRef.current?.setFieldsValue({
        mainNet: initFormValue.mainNet,
        address: cryptoTradingStore.orderInfo.receivingAddress,
        amount: cryptoTradingStore.form.amount,
        paymentType: [cryptoTradingStore.form.paymentType],
        current,
      })
    }
  }, [isTrading])
  const onFormRef = useCallback((form: FormInstance) =>{
    formRef.current = form;
    form.setFieldsValue(initFormValue);
    cryptoTradingStore.fetchDepositDetail(isBuyVb, orderType);
    if( initFormValue.paymentType[0]){
      cryptoTradingStore.fetchBusinessGetAccountInfo(initFormValue.paymentType[0])
    }
  },[])

  useEffect(() => {
    formRef.current?.setFieldsValue({address: cryptoTradingStore.cryptoAccountInfo.address});
  }, [cryptoTradingStore.cryptoAccountInfo.address])

   // 提交订单
  const submit = async ()=>{
    const data = formRef.current?.getFieldsValue();
    const valiedateMsg = valiedateData(data);
    if(valiedateMsg){
      return Toast.show(valiedateMsg)
    }
    // TODO: 验证资金密码
    const securePassword = await verifySecurePassword();
    if (!securePassword) return;

    const { ok, msg } = await businessDeposit({
        paymentType: data.paymentType[0],
        amount: parseFloat(data.amount).toFixed(2),
        passageType: orderType,
        receivingAddress: data.address,
        securePassword: securePassword as string,
    })
    if (ok) {
      Toast.show("订单创建成功");
      cryptoTradingStore.fetchDepositDetail(isBuyVb, orderType);
    } else {
      Toast.show(msg);
    }

  }

  const onSubmit = useCallback(() => {
    if(isTrading){
      navigate(`/trade/crypto_trading/${cryptoTradingStore.orderInfo.orderNo}`)
    }else{
      submit();
    }
  }, [isTrading])



  const onValuesChange = (values:any, allValues: any) => {
    const changeKeys = Object.keys(values);
    if(changeKeys.includes('paymentType')){
      if(!isEqual(allValues.paymentType, data.paymentType)){
        cryptoTradingStore.fetchBusinessGetAccountInfo(values.paymentType[0]);
        allValues.amount = 0;
        formRef.current?.setFieldsValue({amount: 0,current: 0})
        setData(allValues);
      }
    }

    if(changeKeys.includes('amount')){
      const current = coutCurrent( cryptoTradingStore.cryptoAccountInfo, values);
      return formRef.current?.setFieldValue('current', current);
    }
  }

  return {
    onFormRef,
    data:{...data, otcTicker: cryptoTradingStore.cryptoAccountInfo.otcTicker},
    onSubmit,
    isTrading,
    cryptoAccountInfo: cryptoTradingStore.cryptoAccountInfo,
    countdown: cryptoTradingStore.countdown,
    onValuesChange,
  }
}
